module.exports = __webpack_public_path__ + "static/img/salon_question_zh_h5.c4a3ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_question_zh_h5.png
// module id = snju
// module chunks = 34